module.exports = __webpack_public_path__ + "91d0b04be109c172f5ac7e3472b960d0.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/temporal-weave.webm
// module id = 654
// module chunks = 0